var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTranslation)?_c('div',{staticClass:"severity",class:_vm.severityClass},[_vm._v(" "+_vm._s(_vm.$t(_vm.issue.severity))+" ")]):_c('div',{staticClass:"severity",class:_vm.severityClass},[_vm._v(" "+_vm._s(_vm.issue.severity)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }